import Axios from "axios";
import token from "./setToken";

export default {
  async setAnsPeriod(dest) {
    let params = new URLSearchParams();
    params.append("dest", JSON.stringify(dest));

    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantSetAnsPeriod", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("回答受付期間を保存できません[setAnsPeriod]");
      throw error;
    }
  },

  async updateBulkAnsPeriod(updateList, bulkAnsPeriodFrom, bulkAnsPeriodTo) {
    let params = new URLSearchParams();
    params.append("updateList", JSON.stringify(updateList));
    params.append("bulkAnsPeriodFrom", JSON.stringify(bulkAnsPeriodFrom));
    params.append("bulkAnsPeriodTo", JSON.stringify(bulkAnsPeriodTo));
 
    try {
      // await token.checkToken();
      const res = await Axios.post("/api/RefrigerantBulkAnsPeriod", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("冷媒調査回答 回答受付期間を変更できません[updateBulkAnsPeriod]");
      throw error;
    }
  },
};
